import { Trans } from '@lingui/macro';
import { observer } from 'mobx-react-lite';
import React, { FC, useContext, useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import { Context } from '../..';
import AuthService from '../../services/AuthService';
import UserService from '../../services/UserService';
import { ModalPopoverRightTop } from '../pages/modal/modal-popover-rt';
import { PrivPolModal } from './PrivacyPolicyModal';


const Lang: FC = () => {

    const { store } = useContext(Context);

    return (
        <div>
            <table className="table">
                <tbody style={{ cursor: "pointer" }}>
                    <tr onClick={() => store.setLang("ba")}>
                        <td>Башҡортса</td>
                    </tr>
                    <tr onClick={() => store.setLang("ru")}>
                        <td>Русский</td>
                    </tr>
                    <tr onClick={() => store.setLang("en")}>
                        <td>English</td>
                    </tr>
                </tbody>
            </table>
        </div>
    );
};


const PassReset: FC = () => {
    const [email, setEmail] = useState<string>('');
    const [privPolModal, setPrivPolModal] = useState<boolean>(false);
    const [langToggle, setLangToggle] = useState<boolean>(false);
    const { store } = useContext(Context);
    const [emails, setEmails] = useState([]);

    const getEmails = async () => {
        const res = await UserService.getUsers();
        setEmails(res.data.results)
    }

    useEffect(() => {
        getEmails();
    }, [])

    const resetPass = async () => {
        if (emails.find(i => i['email'] === email)) {
            try {
                await AuthService.passReset({ email });
                alert(store.lang === 'ba' ? 'Аккаунтығыҙҙың паролен ташлау өсөн үҙегеҙгә тигән хатта күрһәтелгән һылтанма буйынса үтегеҙ.' : store.lang === 'ru' ? 'Для сброса пароля Вашего аккаунта пройдите по ссылке, которая указана в письме в Вашем email.' : 'To reset your account password, follow the link provided in the email in your email.')
            } catch (e) {
                console.log(e);
                alert(store.lang === 'ba' ? 'Хата' : store.lang === 'ru' ? 'Ошибка' : 'Error')
            }
        } else {
            alert(store.lang === 'ba' ? 'Ундай аккаунт юҡ' : store.lang === 'ru' ? 'Такого аккаунта не существует' : 'There is no such account')
        }
    }


    return (<>
        <div className="row justify-content-end">
            <div className="col-2">
                <Link className="nav-link text-dark" to="" onClick={() => setLangToggle(true)}><i className='icon dark-language' /><Trans>English</Trans></Link>
            </div>
        </div>

        <div className="row justify-content-center">
            <div className="col-2">
                <Link className="nav-link text-light" to="/">
                    <img src='/images/morb.png' alt='logo' className='login-form-logo' />
                </Link>
            </div>
        </div>

        <form className='row mt-5'>
            <div className='mb-4 row justify-content-center'>
                <label className="form-label col-3 col-md-1"><Trans>Email</Trans></label>
                <div className="col-7 col-md-3">
                    <input
                        type="email"
                        className="form-control"
                        onChange={e => setEmail(e.target.value)}
                        value={email}
                        placeholder='login@host.com'
                    />
                </div>
            </div>
            <div className='row justify-content-center'>
                <div className="col-6 col-md-2">
                    <button
                        type="button"
                        className="btn btn-primary w-100"
                        onClick={resetPass}
                    ><Trans>Reset Password</Trans></button>
                </div>
            </div>
        </form>
        <ModalPopoverRightTop
            toggle={langToggle}
            setToggle={setLangToggle}
            title={store.lang === 'ba' ? 'Телде һайлағыҙ' : store.lang === 'ru' ? 'Выберите язык' : 'Сhoose the language'}
            modalContent={<Lang />}
            clickedButtonOne={() => { }}
            clickedButtonTwo={() => setLangToggle(false)}
            ButtonOneValue=''
            ButtonTwoValue=''
        />
        <PrivPolModal toggle={privPolModal} setToggle={setPrivPolModal} />
    </>
    )
};
export default observer(PassReset);